const applyWays = [
  {
    name: "Applied for the job on behalf of the beneficiaries",
    value: "APPLIED_FOR_BENEFICIARY",
  },
  {
    name: "Forwarded the link to matched beneficiaries",
    value: "FORWARD_TO_MATCHED",
  },
];

export default applyWays;
